export const Urls = {
    GetMdrMappings: "DataSteward/GetMdrMappings",
    GetEntityValuesFromSources: "DataSteward/GetEntityValuesFromSources",
    GetEntityPropertyDataHistory: "DataSteward/GetEntityPropertyDataHistory",
    PushOverriddenValues: "DataSteward/PushOverriddenValues"
};
